import { render, staticRenderFns } from "./crearmaterial.vue?vue&type=template&id=1bf9852f&scoped=true"
import script from "./crearmaterial.vue?vue&type=script&lang=js"
export * from "./crearmaterial.vue?vue&type=script&lang=js"
import style0 from "./crearmaterial.vue?vue&type=style&index=0&id=1bf9852f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf9852f",
  null
  
)

export default component.exports